// src/main.js
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

import './style.css';
import 'vue-datepicker-next/index.css';

let app;

// This is the critical part.
// We are now listening for Firebase's authentication state to be ready.
onAuthStateChanged(auth, (user) => {
    // We only want to create and mount the app ONCE.
    if (!app) {
        app = createApp(App);

        const pinia = createPinia();
        app.use(pinia);

        app.use(router);
        app.mount('#app');
    }

    // You can add logic here if you need to react to user login/logout globally,
    // but for now, the key is simply waiting before we mount.
    if (user) {
        console.log("Firebase Auth state changed: User is logged in.", user.uid);
    } else {
        console.log("Firebase Auth state changed: User is logged out.");
    }
});